import { useState } from 'react';

import { CheckedCheckbox, EmptyCheckbox } from './CheckboxSvg';
import styles from './CustomCheckbox.module.css';

interface CustomCheckboxProps {
    id: string;
    label: string;
    onChange: (event: { target: { id: string; checked: boolean } }) => void;
}

export function CustomCheckbox({ id, label, onChange }: CustomCheckboxProps) {
    const [checked, setChecked] = useState(false);

    const handleChange = () => {
        const nextChecked = !checked;
        setChecked(nextChecked);
        onChange({ target: { id, checked: nextChecked } });
    };

    return (
        <label className={styles.formControlLabel}>
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={handleChange}
                className={styles.hiddenInput}
            />
            <span className={styles.checkboxIcon}>
                {checked ? <CheckedCheckbox /> : <EmptyCheckbox />}
            </span>
            <span className={styles.label}>{label}</span>
        </label>
    );
}
